var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "file-system-level",
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c("input", {
        ref: "fileInput",
        staticClass: "file-input-hidden",
        attrs: { type: "file", multiple: "" },
        on: { change: _vm.handleFiles }
      }),
      _vm.filteredItems.length === 0
        ? _c("div", { staticClass: "file-empty-state" }, [
            _c(
              "span",
              { staticClass: "file-empty-icon" },
              [_c("portal-icon", { attrs: { name: "file-text", size: 20 } })],
              1
            ),
            _c("span", [_vm._v("No uploaded file attachments.")])
          ])
        : _vm._e(),
      _vm._l(_vm.filteredItems, function(item) {
        return [
          _c(
            "div",
            {
              key: "main" + item.id,
              staticClass: "file-table-row file-table-grid",
              class: { "is-deleted": item.isDeleted || _vm.parentDeleted },
              on: {
                contextmenu: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.showContextMenu($event, item)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "file-name-cell",
                  style: { paddingLeft: 12 + _vm.depth * 18 + "px" },
                  attrs: {
                    draggable: !_vm.readOnly,
                    "data-drop-enabled": _vm.canUpload ? "true" : "false",
                    "data-asset-type": item.assetType,
                    "data-asset-id": item.id,
                    id: item.id
                  },
                  on: {
                    dragover: _vm.handleDragOver,
                    drop: _vm.handleDrop,
                    dragstart: _vm.handleDragStart,
                    dragenter: _vm.handleDragEnter,
                    dragleave: _vm.handleDragLeave
                  }
                },
                [
                  item.assetType === "Folder"
                    ? _c(
                        "button",
                        {
                          staticClass: "file-tree-toggle",
                          attrs: {
                            type: "button",
                            "aria-expanded": _vm.isExpanded(item)
                              ? "true"
                              : "false"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toggle(item)
                            }
                          }
                        },
                        [
                          _c("portal-icon", {
                            attrs: {
                              name: _vm.isExpanded(item)
                                ? "chevron-down"
                                : "chevron-right",
                              size: 15
                            }
                          })
                        ],
                        1
                      )
                    : _c("span", {
                        staticClass: "file-tree-spacer",
                        class: { "is-root-file": _vm.depth === 0 }
                      }),
                  item.assetType === "Folder"
                    ? _c(
                        "button",
                        {
                          staticClass: "file-type-icon is-folder",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toggle(item)
                            }
                          }
                        },
                        [
                          _c("portal-icon", {
                            attrs: {
                              name: _vm.isExpanded(item)
                                ? "folder-open"
                                : "folder",
                              size: 18
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "file-type-icon",
                          attrs: { type: "button", "aria-label": item.name },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.activateItem(item)
                            }
                          }
                        },
                        [
                          item.fileIconUrl
                            ? _c("img", {
                                attrs: {
                                  src: item.fileIconUrl,
                                  alt: "",
                                  draggable: "false"
                                }
                              })
                            : _c("portal-icon", {
                                attrs: { name: "file-text", size: 17 }
                              })
                        ],
                        1
                      ),
                  _c(
                    "div",
                    {
                      directives: [{ name: "tippy", rawName: "v-tippy" }],
                      staticClass: "file-name-text",
                      class: {
                        "deleted-item": item.isDeleted || _vm.parentDeleted
                      },
                      attrs: {
                        contenteditable:
                          item.isDeleted ||
                          _vm.parentDeleted ||
                          _vm.isDragging ||
                          _vm.readOnly
                            ? "false"
                            : "true",
                        title: item.name,
                        content: item.notes
                      },
                      on: {
                        mousedown: _vm.handleMouseDown,
                        input: function($event) {
                          return _vm.handleInput($event, item)
                        },
                        keydown: function($event) {
                          return _vm.preventLineBreak($event)
                        },
                        blur: function($event) {
                          return _vm.saveName(item)
                        },
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.readOnly ? _vm.activateItem(item) : null
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(item.name) + " ")]
                  )
                ]
              ),
              _c(
                "div",
                {
                  directives: [{ name: "tippy", rawName: "v-tippy" }],
                  staticClass: "file-meta file-col-modified",
                  attrs: {
                    content: _vm.DateTime.fromISO(item.updated).toLocaleString(
                      _vm.DateTime.DATETIME_SHORT
                    )
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$formatters.formatForTimeAgo(item.updated)) +
                      " "
                  )
                ]
              ),
              _c(
                "div",
                {
                  directives: [{ name: "tippy", rawName: "v-tippy" }],
                  staticClass: "file-meta file-col-size",
                  attrs: {
                    content: item.size
                      ? _vm.$formatters.formatBytes(item.size)
                      : null
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        item.size ? _vm.$formatters.formatBytes(item.size) : "—"
                      ) +
                      " "
                  )
                ]
              ),
              _c("div", { staticClass: "file-meta file-col-version" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      item.versions && item.versions.length
                        ? item.versions.length
                        : "—"
                    ) +
                    " "
                )
              ]),
              _c("div", { staticClass: "file-row-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "file-more-action",
                    attrs: {
                      type: "button",
                      "aria-label": item.name,
                      "aria-haspopup": "menu"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.showContextMenu($event, item, true)
                      }
                    }
                  },
                  [
                    _c("portal-icon", { attrs: { name: "ellipsis", size: 18 } })
                  ],
                  1
                )
              ])
            ]
          ),
          item.assetType === "Folder" && _vm.isExpanded(item)
            ? _c("file-system", {
                key: "children" + item.id,
                ref: "children-" + item.id,
                refInFor: true,
                attrs: {
                  "parent-folder-id": item.id,
                  "show-deleted": _vm.showDeleted,
                  "parent-deleted": item.isDeleted || _vm.parentDeleted,
                  depth: _vm.depth + 1,
                  "is-dragging": _vm.isDragging,
                  "sort-by": _vm.sortBy,
                  "sort-dir": _vm.sortDir,
                  "read-only": _vm.readOnly,
                  "allow-upload": _vm.allowUpload
                }
              })
            : _vm._e()
        ]
      }),
      _vm.depth === 0
        ? _c("div", {
            staticClass: "file-root-drop-target",
            attrs: {
              "data-drop-enabled": _vm.canUpload ? "true" : "false",
              "data-asset-type": "Folder",
              "data-asset-id": _vm.parentFolderId
            },
            on: {
              dragover: _vm.handleDragOver,
              drop: _vm.handleDrop,
              dragstart: _vm.handleDragStart,
              dragenter: _vm.handleDragEnter,
              dragleave: _vm.handleDragLeave,
              click: function($event) {
                $event.stopPropagation()
              },
              contextmenu: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.showContextMenu($event, null)
              }
            }
          })
        : _vm._e(),
      _c(
        "v-menu",
        {
          attrs: {
            "position-x": _vm.contextMenu.x,
            "position-y": _vm.contextMenu.y,
            absolute: "",
            "offset-y": "",
            "content-class": "file-context-menu-surface"
          },
          model: {
            value: _vm.contextMenu.visible,
            callback: function($$v) {
              _vm.$set(_vm.contextMenu, "visible", $$v)
            },
            expression: "contextMenu.visible"
          }
        },
        [
          _c(
            "div",
            { staticClass: "file-context-menu", attrs: { role: "menu" } },
            [
              _vm.contextActionItem &&
              _vm.contextActionItem.assetType === "File" &&
              _vm.isImageType
                ? _c(
                    "button",
                    {
                      staticClass: "file-context-menu-item",
                      attrs: { type: "button" },
                      on: { click: _vm.openFile }
                    },
                    [
                      _c("portal-icon", { attrs: { name: "eye", size: 16 } }),
                      _c("span", [_vm._v("Open")])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.contextActionItem &&
              _vm.contextActionItem.assetType === "File"
                ? _c(
                    "button",
                    {
                      staticClass: "file-context-menu-item",
                      attrs: { type: "button" },
                      on: { click: _vm.downloadFile }
                    },
                    [
                      _c("portal-icon", {
                        attrs: { name: "download", size: 16 }
                      }),
                      _c("span", [_vm._v("Download")])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.contextActionItem &&
              _vm.contextActionItem.assetType === "File"
                ? _c("div", { staticClass: "file-context-menu-divider" })
                : _vm._e(),
              !_vm.contextMenu.moreMenu &&
              _vm.canUpload &&
              (!_vm.contextActionItem || !_vm.contextActionItem.isDeleted)
                ? _c(
                    "button",
                    {
                      staticClass: "file-context-menu-item",
                      attrs: { type: "button" },
                      on: { click: _vm.handleUploadFile }
                    },
                    [
                      _c("portal-icon", {
                        attrs: { name: "upload", size: 16 }
                      }),
                      _c("span", [_vm._v("Upload file")])
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.contextMenu.moreMenu &&
              !_vm.readOnly &&
              (!_vm.contextActionItem || !_vm.contextActionItem.isDeleted)
                ? _c(
                    "button",
                    {
                      staticClass: "file-context-menu-item",
                      attrs: { type: "button" },
                      on: { click: _vm.handleNewFolder }
                    },
                    [
                      _c("portal-icon", {
                        attrs: { name: "folder-plus", size: 16 }
                      }),
                      _c("span", [_vm._v("New folder")])
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.readOnly && _vm.contextActionItem
                ? _c("div", { staticClass: "file-context-menu-divider" })
                : _vm._e(),
              !_vm.readOnly && _vm.contextActionItem
                ? _c(
                    "button",
                    {
                      staticClass: "file-context-menu-item is-danger",
                      attrs: { type: "button" },
                      on: { click: _vm.deleteItem }
                    },
                    [
                      _c("portal-icon", {
                        attrs: { name: "trash-2", size: 16 }
                      }),
                      _c("span", [_vm._v("Delete")])
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm.lightBoxUrl
        ? _c("light-box", {
            attrs: { url: _vm.lightBoxUrl, "file-name": _vm.lightBoxFileName },
            on: {
              close: function($event) {
                return _vm.closeLightBox()
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }